export const ClickOutside = {
    mounted: (el, bindings) => {
        el.clickOutsideEvent = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                bindings.value(event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
};
